const volumeOn = true

export const toggleVolume = () => {
    return {type: 'TOGGLE_VOLUME'}
}

const reducer = (state = volumeOn, action) => {
    switch (action.type) {
        case 'TOGGLE_VOLUME':
            return !state
        default: return state    
    }
}

export default reducer